import React, { useState } from "react";
import { Button } from "components/ui";

const ReadMore = ({ expanded = false, comment, maxChar = 100, className }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const maxCharCount = maxChar; // Maximum characters to show when collapsed

  const handleToggle = (event) => {
    setIsExpanded(!isExpanded);
    event.preventDefault();
  };

  const truncatedText =
    comment?.length > maxCharCount && !isExpanded
      ? `${comment.slice(0, maxCharCount)}.....`
      : comment;

  return (
    <p className={`break-all ${className}`}>
      {truncatedText}
      {comment?.length > maxCharCount && (
        <Button
          size="small"
          className="bg-transparent hover:bg-transparent text-[#2563eb] shadow-none text-[12px] ml-2"
          onClick={(e) => handleToggle(e)}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </Button>
      )}
    </p>
  );
};

export default ReadMore;
